import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import groupService from "../services/group";

const initialState = {
  groups: []
};

export const getGroups = createAsyncThunk(
  "group/get",
  async (info) => {
    const res = await groupService.getGroups(info);
    return res.data;
  }
)

export const createGroup = createAsyncThunk(
  "group/create",
  async (info) => {
    const res = await groupService.createGroup(info);
    return res.data;
  }
);

export const updateGroup = createAsyncThunk(
  "group/update",
  async (info) => {
    const res = await groupService.updateGroup(info);
    return res.data;
  }
);

export const deleteGroup = createAsyncThunk(
  "source/delete",
  async (id) => {
    const res = await groupService.deleteGroup(id);
    return res.data;
  }
);

export const assignSourceToGroup = createAsyncThunk(
  "source/assignDb",
  async (info) => {
    const res = await groupService.assignSourceToGroup(info);
    return res.data;
  }
);

export const assignUserToGroup = createAsyncThunk(
  "source/assignUser",
  async (info) => {
    const res = await groupService.assignUserToGroup(info);
    return res.data;
  }
);

export const getSourceOfGroup = createAsyncThunk(
  "source/source",
  async (info) => {
    const res = await groupService.getSources(info);
    return res.data;
  }
);

export const getUserOfGroup = createAsyncThunk(
  "source/user",
  async (info) => {
    const res = await groupService.getUsers(info);
    return res.data;
  }
);


const groupSlice = createSlice({
  name: 'group',
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(getGroups.fulfilled, (state, action) => {
      state.groups = action.payload;
    })
    builder.addCase(createGroup.fulfilled, (state, action) => {
      const {id, name, api_key, created_at} = action.payload;
      state.groups.push({id, name, api_key, users: [], sources: [], created_at});
    })
    builder.addCase(updateGroup.fulfilled, (state, action) => {
      const {id, name, api_key, created_at} = action.payload;
      const newGroup = state.groups.map(group => {
        if(group.id === id) 
          return {
            id, 
            name, 
            api_key, 
            created_at
          }
        else
          return group;
      })
      state.groups = newGroup
    })
    builder.addCase(deleteGroup.fulfilled, (state, action) => {
      const {success, id} = action.payload;
      if(success) {
        const newGroup = state.groups.filter(item => item.id!=id);
        console.log(id, newGroup)
        state.groups = newGroup;
      }
    })
    builder.addCase(assignSourceToGroup.fulfilled, (state, action) => {
      const {success, group, dbs} = action.payload;
      if(success) {
        let groupData;
        const newGroups = state.groups.map(item => {
          if(item.name === group) {
            groupData = {...item, sources: dbs}
            return groupData;
          }
          return item;
        });
        state.groups = newGroups;
      }
    })
    builder.addCase(assignUserToGroup.fulfilled, (state, action) => {
      const {success, group, users} = action.payload;
      if(success) {
        let groupData;
        const newGroups = state.groups.map(item => {
          if(item.name === group) {
            groupData = {...item, users}
            return groupData;
          }
          return item;
        });
        state.groups = newGroups;
      }
    })
    builder.addCase(getSourceOfGroup.fulfilled, (state, action) => {
      console.log(action.payload)
    })
    builder.addCase(getUserOfGroup.fulfilled, (state, action) => {
      console.log(action.payload)
    })
  }
})

// export const {
//   changePermission, 
//   changeRole
// } = permissionSlice.actions;

const { reducer } = groupSlice;
export default reducer;